import React from 'react';
import { Info } from 'lucide-react';

interface LegacyBothNoticeProps {
  onDismiss: () => void;
}

export const LegacyBothNotice: React.FC<LegacyBothNoticeProps> = ({ onDismiss }) => {
  return (
    <div
      className="bg-amber-50 border border-amber-200 rounded-lg p-4 flex items-start gap-3"
      role="status"
    >
      <Info className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" aria-hidden />
      <div className="flex-1 text-amber-900 text-sm space-y-2">
        <p className="font-medium">Choose text or image</p>
        <p>
          Combined text + image logos are no longer supported. Pick <strong>Text Only</strong> or{' '}
          <strong>Image Only</strong> below.
        </p>
        <p>
          If you save an <strong>image</strong> logo, your previous logo text is copied into{' '}
          <strong>Fallback site name</strong> when that field is empty, so your brand name still
          appears if the image fails to load.
        </p>
        <button
          type="button"
          onClick={onDismiss}
          className="text-amber-800 underline hover:text-amber-950 font-medium"
        >
          Got it
        </button>
      </div>
    </div>
  );
};
